'use strict';

import versioner from '../versioner';
import process from './process';

versioner['springfield_sewer_after_hours'] = {
	process: process,
}

const MODULE_NAME = 'daupler.incidents.versions.springfield';

export default MODULE_NAME;
